import {
  can,
} from "../../shared/auth/access";
import type {
  useSuppliersWorkspace,
} from "./useSuppliersWorkspace";

export function SupplierOverview({ model }: { model: ReturnType<typeof useSuppliersWorkspace> ;}) {
  const { user, supplierTab, supplierAction, setSupplierAction, supplierActionPending, nextStatus, setNextStatus, supplierGovernance, selectedSupplier, changeSupplierStatus } = model;
  if (!selectedSupplier) return null;
  return (<>{supplierTab === "overview" ? (
    <div className="supplier-overview">
      <section>
        <h3>Ticari kimlik</h3>
        <dl>
          <div>
            <dt>Ticari unvan</dt>
            <dd>
              {selectedSupplier.legalName ?? "Belirtilmedi"}
            </dd>
          </div>
          <div>
            <dt>Kategori</dt>
            <dd>{selectedSupplier.category}</dd>
          </div>
          <div>
            <dt>Performans</dt>
            <dd>
              {selectedSupplier.score}/5{" "}
              <small>Resmî kalite kararı değildir</small>
            </dd>
          </div>
        </dl>
      </section>
      {supplierGovernance ? (
        <section className="supplier-governance-summary">
          <h3>Satın alma ve uygunluk özeti</h3>
          <dl>
            <div>
              <dt>Aktif sözleşme</dt>
              <dd>{supplierGovernance.activeContracts}</dd>
            </div>
            <div>
              <dt>Kalan sözleşme limiti</dt>
              <dd>
                {new Intl.NumberFormat("tr-TR", {
                  style: "currency",
                  currency: "TRY",
                }).format(
                  supplierGovernance.remainingContractLimit,
                )}
              </dd>
            </div>
            <div>
              <dt>Açık DÖF</dt>
              <dd>{supplierGovernance.openCapas}</dd>
            </div>
            <div>
              <dt>30 günde süresi dolan belge</dt>
              <dd>{supplierGovernance.expiringDocuments}</dd>
            </div>
            <div>
              <dt>Sipariş geçmişi</dt>
              <dd>{supplierGovernance.orderCount}</dd>
            </div>
            <div>
              <dt>Zamanında teslimat</dt>
              <dd>
                {supplierGovernance.onTimeRate === null
                  ? "Veri yok"
                  : `%${Math.round(supplierGovernance.onTimeRate * 100)}`}
              </dd>
            </div>
          </dl>
        </section>
      ) : null}
      {can(user, "supplier.identity.manage") ? (
        <>
          <button
            className="primary-button"
            onClick={() => setSupplierAction("status")}
          >
            Durumu yönet
          </button>
          {supplierAction === "status" ? (
            <div className="supplier-action-drawer">
              <h3>Durumu değiştir</h3>
              <label>
                Yeni durum
                <select
                  value={nextStatus}
                  onChange={(event) =>
                    setNextStatus(event.target.value)
                  }
                >
                  <option value="DRAFT">Taslak</option>
                  <option value="UNDER_REVIEW">
                    İncelemede
                  </option>
                  <option value="ACTIVE">Aktif</option>
                  <option value="SUSPENDED">Askıda</option>
                  <option value="BLOCKED">Engelli</option>
                  <option value="ARCHIVED">Arşivlendi</option>
                </select>
              </label>
              <div className="inline-form-actions">
                <button
                  className="secondary-button"
                  onClick={() => setSupplierAction(null)}
                >
                  Vazgeç
                </button>
                <button
                  className="approve-button"
                  disabled={supplierActionPending}
                  onClick={changeSupplierStatus}
                >
                  Durumu sunucuda doğrula ve değiştir
                </button>
              </div>
            </div>
          ) : null}
        </>
      ) : (
        <p className="readonly-note">Bu alan salt okunur.</p>
      )}
    </div>
  ) : null}</>);
}
